<template>
  <div>
    <vx-card style="margin-bottom: 15px">
      <b-row align-v="center">
        <b-col lg="1" sm="12">
          <label for="datepicker-sm">Tarih: </label></b-col
        >

        <b-col lg="3" sm="5">
          <b-form-datepicker
            id="datepickerbaslangic"
            v-model="datepickerbaslangic"
            local="en"
            today-variant="danger"
            placeholder="Başlangıç tarihi"
            :start-weekday="weekday"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric'
            }"
          />
        </b-col>
        <b-col lg="3" sm="5">
          <b-form-datepicker
            id="datepickerbitis"
            v-model="datepickerbitis"
            placeholder="Bitiş tarihi"
            local="en"
            today-variant="danger"
            :start-weekday="weekday"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric'
            }"
          />
        </b-col>
        <b-col lg="3" sm="5">
          <b-form-input
            v-model="arananDeger"
            @keyup.enter="getTahsilatRaporList"
            id="smallInput"
            placeholder="Arama..."
          />
        </b-col>
        <b-col lg="2" sm="5">
          <vs-button
            style="border-radius: 5px; width: 100%"
            type="gradient"
            size=""
            @click="listele()"
            id="button-with-loading-yeni"
            class="vs-con-loading__container"
            >Listele</vs-button
          >
        </b-col>
      </b-row>
    </vx-card>
    <vx-card>
      <b-row style="margin-bottom: 10px">
        <b-col lg="2" sm="5">
          <ButtonPrimary
            :title="filtretitle"
            :size="filtresize"
            @test-click="resetState"
            :color="filtrecolor"
          />
        </b-col>
      </b-row>
      <ag-grid-vue
        style="width: 100%; height: 500px"
        class="ag-theme-alpine"
        :rowSelection="rowSelection"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :localeText="localeText"
        :pagination="true"
        @grid-ready="onGridReady"
        @first-data-rendered="onFirstDataRendered"
      >
      </ag-grid-vue>
    </vx-card>
  </div>
</template>
<script>
import Store from "../../store/store";
import state from "../../store/state";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import moment from "moment";
import ButtonPrimary from "../components/crm-components/global-components/ButtonPrimary.vue";
import TahsilatRaporDetay from "../components/crm-components/finans-components/TahsilatRaporDetay.vue";

export default {
  data() {
    return {
      weekday: 1,
      filtrecolor: "success",
      size: "",
      title: "Listele",
      filtresize: "small",
      filtretitle: "Filtrelemeyi Resetle",
      frameworkComponents: null,
      localeText: null,
      columnDefs: null,
      rowData: null,
      datepickerbaslangic: "",
      datepickerbitis: "",
      columnApi: null,
      arananDeger: "",
      dir: false,
      searchTerm: "",
      pageLength: 10,
      rows: [],
      columns: null,
      gelenfiltre: "",
      rowSelection: null,
      defaultColDef: {
        sortable: true,
        resizable: true
      }
    };
  },
  components: {
    ButtonPrimary,
    AgGridVue,
    TahsilatRaporDetay
  },
  beforeMount() {
    this.columnDefs = [
      {
        width: 100,
        field: "",
        cellRendererFramework: "TahsilatRaporDetay"
      },
      {
        headerName: "Cari No",
        field: "ACTID",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Cari Adı",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "İşlem No",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        field: "ACTNO"
      },
      {
        headerName: "Tarih",
        field: "TARIH",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: this.parseDate
      },
      {
        headerName: "Personel",
        field: "PERSONEL",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Borç",
        field: "BORCTOPLAM",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        valueFormatter: params =>
          this.currencyFormatter(params.data.BORCTOPLAM, "₺")
      },
      {
        headerName: "Borç Vade",
        field: "BORCVADE",
        valueFormatter: this.parseDate,
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Tahsilat",
        field: "ALACAKTOPLAM",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        valueFormatter: params =>
          this.currencyFormatter(params.data.ALACAKTOPLAM, "₺")
      },
      {
        headerName: "Tahsilat Vade",
        field: "ALACAKVADE",
        sortable: true,
        valueFormatter: this.parseDate,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Açıklama",
        field: "ACIKLAMA",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      }
    ];
  },
  created() {
    this.rowSelection = "single";
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
  },
  methods: {
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    currencyFormatter(currency, sign) {
      if (currency == "") {
        return "";
      } else {
        var sansDec = currency.toFixed(2);
        var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return sign + `${formatted}`;
      }
    },
    resetState() {
      this.gridApi.setFilterModel(null);
      this.gelenfiltre = "";
      this.getTahsilatRaporList();
    },
    onFilterModified(e) {
      if (e.filterInstance.getModelFromUi() == null) console.log("in");
      else this.gelenfiltre = e.filterInstance.getModelFromUi().filter;
    },
    listele() {
      this.getTahsilatRaporList();
    },
    onSelectionChanged(params) {
      this.$store.commit("account/TAHSILAT_DETAY", params.node.data);
    },
    parseDate(params) {
      return moment(String(params.value)).format("DD.MM.YYYY");
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.getTahsilatRaporList();
    },
    getNow() {
      const today = new Date();
      const date =
        today.getDate() +
        "." +
        (today.getMonth() + 1) +
        "." +
        today.getFullYear();

      const dateTime = date;
      return dateTime;
    },
    getLastTreeMonth() {
      var d = new Date();
      d.setMonth(d.getMonth() - 3);
      return d.toLocaleDateString();
    },
    getTahsilatRaporList(e) {
      var vm = this;
      var vs = this.$vs;
      vs.loading({
        background: "#0064fa",
        color: "#fff",
        container: "#button-with-loading-yeni",
        scale: 0.45
      });
      var bitis, baslangic;
      if (this.datepickerbaslangic == "") {
        baslangic = vm.getLastTreeMonth();
      } else
        baslangic = moment(String(this.datepickerbaslangic)).format(
          "DD.MM.YYYY"
        );
      if (this.datepickerbitis == "") {
        bitis = vm.getNow();
      } else bitis = moment(String(this.datepickerbitis)).format("DD.MM.YYYY");
      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {};
      if (vm.gelenfiltre == "") {
        args = {
          token: Store.state.tokenId,
          ARANAN: vm.arananDeger,
          ILKTARIH: baslangic,
          SONTARIH: bitis
        };
        soap.createClient(url, function(err, client) {
          client.INT_TAHSILAT_RAPORU(args, function(err, result) {
            if (result.INT_TAHSILAT_RAPORUResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.INT_TAHSILAT_RAPORUResult);
              if (vm.veriler.response == "Ok") {
                vm.rowData = JSON.parse(vm.veriler.jsonData);
                vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
              } else {
                vs.notify({
                  title: "Uyarı",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center"
                });
                vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
              }
            } catch (error) {
              console.log(error);
              vs.notify({
                title: "Hata",
                text: "Liste getirilirken hata oluştu.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center"
              });
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            }
          });
        });
      } else {
        if (typeof e == "undefined") {
          const vs = this.$vs;
          vs.notify({
            title: "Tahsilat Raporu",
            text: "Öncelikle filtrelemeyi resetleyin.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-center"
          });
          vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
        } else {
          var savedFilterModel = e.api.getFilterModel();
          var keys = Object.keys(savedFilterModel);
          if (keys.length > 1) {
            vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            console.log("arama yapma");
          } else {
            args = {
              token: Store.state.tokenId,
              ARANAN: vm.gelenfiltre,
              ILKTARIH: baslangic,
              SONTARIH: bitis
            };
            soap.createClient(url, function(err, client) {
              client.INT_TAHSILAT_RAPORU(args, function(err, result) {
                if (result.INT_TAHSILAT_RAPORUResult == "-1") {
                  Store.dispatch("logout");
                  //this.$store.dispatch('login', payload)
                }
                try {
                  vm.veriler = JSON.parse(result.INT_TAHSILAT_RAPORUResult);

                  if (vm.veriler.response == "Ok") {
                    vm.rowData = JSON.parse(vm.veriler.jsonData);
                    vs.loading.close(
                      "#button-with-loading-yeni > .con-vs-loading"
                    );
                  } else {
                    vs.notify({
                      title: "Uyarı",
                      text: vm.veriler.message,
                      iconPack: "feather",
                      icon: "icon-alert-circle",
                      color: "warning",
                      position: "top-center"
                    });
                    vs.loading.close(
                      "#button-with-loading-yeni > .con-vs-loading"
                    );
                  }
                } catch (error) {
                  console.log(error);
                  vs.notify({
                    title: "Hata",
                    text: "Liste getirilirken hata oluştu.",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger",
                    position: "top-center"
                  });
                  vs.loading.close(
                    "#button-with-loading-yeni > .con-vs-loading"
                  );
                }

                //  vm.cariHareketlerListesi = vm.veriler;
              });
            });
          }
        }
      }
    },
    direction() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    }
  }
};
</script>
<style lang="scss">
@import "~ag-grid-community/dist/styles/ag-grid.css";
@import "~ag-grid-community/dist/styles/ag-theme-alpine.css";
.ag-theme-alpine .ag-row {
  font-size: 13px;
  height: 35px;
}
</style>
